<template>
  <div class="w-100">
    <div class="d-flex justify-content-between">
      <proa-heading>{{ $t('pages.mySpace.heading') }}</proa-heading>
      <div
        @click="onClickSignedInUser"
        class="user-information d-block d-md-none"
      >
        <proa-avatar
          :src="signedInUser.meta.avatar || require('@/assets/images/avatar_default.png')"
        />
        <div
          v-if="signedInUser.meta.userPresence == 'online'"
          class="presence-icon"
        >
          <proa-user-status-icon
            :user="signedInUser"
            :responsiveIcon="$mq === 'sm'"
          />
        </div>
      </div>
    </div>
    <pickup-members/>
    <meeting-rooms/>
    <invited-meetings/>
    <notifications/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PickupMembers from '@/components/organisms/mySpace/PickupMembers'
import MeetingRooms from '@/components/organisms/mySpace/MeetingRooms'
import InvitedMeetings from '@/components/organisms/InvitedMeetings'
import Notifications from '@/components/organisms/mySpace/Notifications'

export default {
  name: 'MySpace',
  components: {
    PickupMembers,
    MeetingRooms,
    InvitedMeetings,
    Notifications
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  methods: {
    onClickSignedInUser: function() {
      this.$router.push({ name: 'showMember', params: { id: this.signedInUser.id } })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
.user-information {
  position: relative;
  margin-right: 10px;
  img {
    width: 34px !important;
    height: 34px !important;
  }
  .presence-icon {
    position: absolute;
    top: 0;
    left: 0;

    @include mq(lg) {
      top: 4px;
      left: 64px;
    }
  }
}
</style>
